import { withErrorBoundary } from 'react-error-boundary';
import type { TypeStandardTemplateDetailed } from 'types/autogen/contentful';
import TemplateComponentRenderer from '../../shared/TemplateComponentRenderer';
import Layout from 'components/Layout';
import { useIsPreview } from 'components/pages/Contentful/context/PreviewContext';
import { filterPublishedFields } from 'components/pages/Contentful/shared/ContentfulHelpers';

function StandardTemplate(props: TypeStandardTemplateDetailed) {
    const { fields } = props;

    const entriesToRender = filterPublishedFields(fields?.content);

    return (
        <Layout.Page>
            {entriesToRender?.map((x, index) => (
                <TemplateComponentRenderer key={`${x.sys.id}_${index}`} {...x} />
            ))}
        </Layout.Page>
    );
}

export default withErrorBoundary(StandardTemplate, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
